import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/clerk-react';
import './theme/base.css';
import App from './App';

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// Set theme
document.documentElement.dataset.theme = 'neon-dark';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
